import { FC } from "react"
import { ItemInput } from "../../../../../../_webui/layout/components/Form/Item/Input"
import { ItemSelect } from "../../../../../../_webui/layout/components/Form/Item/Select"
import { FormSearchLeft } from "../../../../../../_webui/layout/components/Form/Search/Left"
import { FormSearchRight } from "../../../../../../_webui/layout/components/Form/Search/Right"
import { Translate } from "../../../../../../constant/Translate"
import { TravelerFormSearchProps } from "./modals"
import { ItemRadio } from "../../../../../../_webui/layout/components/Form/Item/Radio"
import { RadioItems } from "../../../../../../constant/RadioItems"
import { SelectItems } from "../../../../../../constant/SelectItems"
import { Styled } from "./styled"

const { WORK_PLACE_LOCATION_SEARCH } = RadioItems
const { OTHER_CITY_SELECT_ITEMS } = SelectItems
const { StyledFormSearch } = Styled
const {
  TEXT_T009,
  TEXT_T025,
  TEXT_T054,
  TEXT_T055,
  TEXT_T056,
  TEXT_T057,
  TEXT_T167,
  TEXT_T192,
} = Translate

export const TravelerFormSearch: FC<TravelerFormSearchProps> = (props) => {
  const {
    allCountries,
    cities,
    countryCode,
    dispatchType,
    departments,
    form,
    isOtherCity,
    isOverseasResident,
    onChangeWorkPlaceCity,
    onChangeWorkPlaceCountry,
    onChangeWorkPlaceLocation,
    onClickReset,
    onFinish,
  } = props

  return (
    <StyledFormSearch
      form={form}
      heading={TEXT_T167}
      labelAlign="left"
      onFinish={onFinish}
      onClickReset={onClickReset}
    >
      <FormSearchLeft>
        <ItemInput label={TEXT_T192} name="fullName" />
        <ItemSelect label={TEXT_T009} name="bumonCd" selectItem={departments} />
        <ItemSelect
          label={TEXT_T025}
          name="dispatchTypeDetailId"
          selectItem={dispatchType}
        />
      </FormSearchLeft>

      <FormSearchRight>
        <ItemRadio
          label={TEXT_T054}
          name="workPlaceLocation"
          radioItems={WORK_PLACE_LOCATION_SEARCH}
          onChange={onChangeWorkPlaceLocation}
        />
        <ItemSelect
          isDisabled={!isOverseasResident}
          label={TEXT_T055}
          name="workPlaceCountry"
          onChange={onChangeWorkPlaceCountry}
          selectItem={allCountries}
        />
        <ItemSelect
          isDisabled={!isOverseasResident || !countryCode}
          label={TEXT_T056}
          name="workPlaceCity"
          onChange={onChangeWorkPlaceCity}
          selectItem={[...(cities ? cities : []), OTHER_CITY_SELECT_ITEMS]}
        />
        <ItemInput
          isDisabled={!isOverseasResident || !countryCode || !isOtherCity}
          label={TEXT_T057}
          maxLength={200}
          name="workPlace"
        />
      </FormSearchRight>
    </StyledFormSearch>
  )
}
